import type React from "react";
import { useEffect, useState } from "react";

import {
    isAfterTrialCCFromQuiz,
    isAfterTrialFromHomeResources,
} from "app/common/after-trial/afterTrialSwSettingsPredicates";
import { swSettings } from "app/common/services/swSettings";
import { DEFAULT_HOMEPAGES } from "app/components/modals/constants";
import { GrowthbookService, TestsNames } from "app/services/trackingServices/GrowthBookService";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { AfterTrialPopup } from "./AfterTrialPopup";
import { AfterTrialPopupLoader } from "./AfterTrialPopupLoader";
import { getPackages } from "./getPackages";
import { StepPackagesCIAndSEOAndAdsDesktop } from "./StepPackagesCIAndSEOAndAdsDesktop/StepPackagesCIAndSEOAndAdsDesktop";
import { StepPackagesCIAndSEOAndAdsDesktopLoader } from "./StepPackagesCIAndSEOAndAdsDesktop/StepPackagesCIAndSEOAndAdsDesktopLoader";
import { StepPackagesCIAndSEODesktop } from "./StepPackagesCIAndSEODesktop/StepPackagesCIAndSEODesktop";
import type { IPackagesPrice } from "./types";

interface IAfterTrialPopupContainer {
    setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
    withCloseIcon?: boolean;
    popUpHeight?: number;
    withBackButton?: boolean;
    onBackClick?: () => void;
    isSI?: boolean;
}
export const AfterTrialPopupContainer: React.FC<IAfterTrialPopupContainer> = ({
    setIsOpen,
    withCloseIcon = true,
    popUpHeight,
    withBackButton,
    onBackClick,
    isSI,
}) => {
    const [packages, setPackages] = useState<IPackagesPrice | null>(null);

    const isSkipTrial = isAfterTrialCCFromQuiz(swSettings);
    const isSalesSolution = proNavigator.isSalesSolution();

    useEffect(() => {
        const fetchData = async () => {
            const workspace = isSI ? DEFAULT_HOMEPAGES.SI : DEFAULT_HOMEPAGES.DMI;
            const response = await getPackages(workspace);
            if (response?.PackagesPrices) {
                setPackages(response.PackagesPrices);
            }
        };
        if (isAfterTrialFromHomeResources(swSettings)) {
            void fetchData();
        }
    }, []);

    const isNewPackagesModal = GrowthbookService.growthbookInstance.isOn(TestsNames.REACTIVATION_PACKAGES_MODAL_V2);

    if (!packages) {
        return !isSI && !isSalesSolution && isNewPackagesModal ? (
            <StepPackagesCIAndSEOAndAdsDesktopLoader setIsOpen={setIsOpen} />
        ) : (
            <AfterTrialPopupLoader popUpHeight={popUpHeight} />
        );
    }

    return !isSI && !isSalesSolution ? (
        isNewPackagesModal ? (
            <StepPackagesCIAndSEOAndAdsDesktop
                packages={packages}
                setIsOpen={setIsOpen}
            />
        ) : (
            <StepPackagesCIAndSEODesktop
                packages={packages}
                setIsOpen={setIsOpen}
                isSkipTrial={isSkipTrial}
            />
        )
    ) : (
        <AfterTrialPopup
            packages={packages}
            setIsOpen={setIsOpen}
            withCloseIcon={withCloseIcon}
            popUpHeight={popUpHeight}
            withBackButton={withBackButton}
            onBackClick={onBackClick}
            isSI={!!isSI}
            isSkipTrial={isSkipTrial}
        />
    );
};
